import { render, staticRenderFns } from "./SettingDownloadApp.vue?vue&type=template&id=5f5f4d5c&"
import script from "./SettingDownloadApp.vue?vue&type=script&lang=js&"
export * from "./SettingDownloadApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports